// extracted by mini-css-extract-plugin
module.exports = {"modal":"_234rm-","placementOnBottom":"_3IGMlX","placementOnTop":"_3Vs3o4","backdrop":"-CqQhT","visible":"_29cwcS","closeIcon":"ml1JVt","shine-lines":"cr5sLE"};